// extracted by mini-css-extract-plugin
export default {"title":"Error_title__5yJzr","desc":"Error_desc__h8Jzm","error":"Error_error__NAxq3","slide-off":"Error_slide-off__uWwr9","show":"Error_show__EJ9Tu","active":"Error_active__SRVeT"};